/* eslint-disable max-len */
export const SEO = {
  mainPage: {
    title: 'Устраивайся на\u00A0работу в\u00A0Купер — присоединяйся к\u00A0нашей команде!',
    description: 'Стань частью команды Купера! Выбери вакансию и присоединяйся к нам! Обучение и развитие! Возможности карьерного роста!',
  },
  tech: {
    title: 'Вакансии в отделе IT (информационные технологии) в Купере. Работай удаленно!',
    description: 'Стань частью команды Купер.тех в сфере IT! Работай в офисе или удаленно! Используем современный стек в backend, frontend, mobile, infrastructure! Работа в кросс-функциональных командах с использованием data-driven подхода!',
  },
  backOffice: {
    title: 'Работа в офисе Купера: актуальные вакансии',
    description: 'Приглашаем на работу в офис Купера в отделы маркетинга, B2B, финансов, HR и другие! Офис в центре Москвы! Амбициозная команда! Возможности карьерного роста!',
  },
  operations: {
    title: 'Работа в операционной сфере Купера: актуальные вакансии',
    description: 'Приглашаем на работу в операционное направление Купера: Оператор колл-центра, Сити-менеджер, Супервайзер и другие вакансии! Амбициозная команда! Возможности карьерного роста!',
  },
  vacancy: {
    title: ': вакансия в Купере',
    description: 'в Купере! Сильное комьюнити! Обучение и\u00A0развитие! Амбициозная команда! Атмосфера вдохновения и\u00A0взаимоуважения! Возможности карьерного роста!',
  },
  news: {
    title: 'Свежие новости Купера',
    description: 'Актуальные новости Купера на\u00A0официальном сайте! Новости в\u00A0области разработки: QA, UX, Golang и\u00A0т.п. Общие новости: спецпроекты, сервис, карьера и\u00A0т.п.',
  },
  catalogVacancies: {
    title: 'Актуальные вакансии в компании Купер',
    description: 'Все актуальные вакансии Купера! Мы — команда профессионалов! Выбери вакансию и присоединяйся к команде!',
  },
};
